import { GeschaeftspartnerDetailPage } from "@/pages/kontakte/GeschaeftspartnerDetailPage";

export function LieferantDetailPage() {
  return (
    <GeschaeftspartnerDetailPage
      typ="lieferant"
      listPath="/kontakte/lieferanten"
      listLabel="Lieferanten"
    />
  );
}
